import React from 'react'
import Link from 'react-router/lib/Link'

const EnrolmentDefault = () => (
  <div className="jumbotron">
    <h1>Enrolment Module</h1>
    <p>Based on your enrolment status, proceed to the following actions.</p>
    <hr />
    <div className="row">
      <div className="col-sm-4 text-center">
        <Link to="/enrolment/apply" className="btn btn-success btn-lg btn-block">Apply for Enrolment</Link>
        <hr />
        If you haven't made any applications for enrolment yet for this semester.
      </div>
      <div className="col-sm-4 text-center">
        <Link to="/enrolment/modify" className="btn btn-info btn-lg btn-block">Modify my Enrolment</Link>
        <hr />
        If you have made your application but has subject modifications provided the registrar hasn't approved your application yet.
      </div>
      <div className="col-sm-4 text-center">
        <Link to="/enrolment/add-withdraw-subjects" className="btn btn-warning btn-lg btn-block">Add/Withdraw Subjects</Link>
        <hr />
        If you are officialy registered and if enrolment is still open, you can add/withdraw subjects.
      </div>
    </div>
  </div>
)

export default EnrolmentDefault



// WEBPACK FOOTER //
// ./src/containers/Enrolment/default.js